// extracted by mini-css-extract-plugin
module.exports = {"item_part_label":"card-part-number_item_part_label__10yT1","item_part_number":"card-part-number_item_part_number__7hgne"};